import { useState } from "react";
import FormStep from "../types/FormStep";

export default function multistepForm(steps: FormStep[], initialStep: number) {
  const [currentStepIndex, setCurrentStepIndex] = useState(initialStep);

  function next() {
    let nextIndex = 0;
    if (steps[currentStepIndex].nextIndex) nextIndex = steps[currentStepIndex].nextIndex!;
    else nextIndex = currentStepIndex;
    setCurrentStepIndex(nextIndex);
  }

  function back() {
    setCurrentStepIndex(i => {
      if (i <= 0) {
        return i;
      }
      return i - 1;
    });
  }

  function goTo(index: number) {
    setCurrentStepIndex(index);
  }

  function isReviewStep() {
    return steps[currentStepIndex].stepName === "Review";
  }

  function isCustomerDetailsStep() {
    return steps[currentStepIndex].stepName === "Customer details";
  }

  return {
    currentStepIndex,
    step: steps[currentStepIndex],
    steps,
    isFirstStep: currentStepIndex === 0,
    isLastStep: currentStepIndex === steps.length - 1,
    goTo,
    next,
    back,
    isReviewStep,
    isCustomerDetailsStep,
  };
}
